module.exports = "<label *ngIf=\"showCaption\" [ngClass]=\"position === 1 ? '' : _captionWidth\">{{\r\n  caption\r\n}}</label>\r\n<div [ngClass]=\"position === 1 ? '' : _fieldWidth\">\r\n  <input\r\n    id=\"fieldName\"\r\n    [disabled]=\"disabled\"\r\n    (keypress)=\"innerChange($event)\"\r\n    type=\"number\"\r\n    class=\"form-control ixsControl\"\r\n    [(ngModel)]=\"value\"\r\n    [max]=\"max\"\r\n    [min]=\"min\"\r\n    (blur)=\"onBlur()\"\r\n    [placeholder]=\"placeholder\"\r\n  />\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ixsnumeric/ixsnumeric.component.html
// module id = 1203
// module chunks = 322